export class ReportGenerationPropertySetTypesDef {
  public static readonly DEFAULT: string = 'DEFAULT';
  public static readonly MOUNTING_RAIL: string = 'MOUNTING_RAIL';

  public static readonly MARKING_SYSTEM: string = 'MARKING_SYSTEM';
  public static readonly XCOM: string = 'XCOM';
  public static readonly CIRCUIT_BOARD: string = 'CIRCUIT_BOARD';
}
